export default __webpack_public_path__ + "img/cmstGLSQ.dc8f95db.svg";